import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
import { TxpEventTypes } from '../store/schema/TxpOptionState';
import { Label } from 'office-ui-fabric-react/lib/Label';
import updateTxpFlag from '../actions/updateTxpFlag';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import {
    getLabelForTxpFlag,
    TxpEventFlags,
    isEventTypeEnabled,
    EventsInOptionsPageInOrder,
} from '../utils/getTxpFlagInfo';

const styles = require('./TxpOptions.scss');

export interface TxpEventsPanelProps {
    formFlags: TxpEventTypes;
    mailboxCalendarConfiguration: MailboxCalendarConfiguration;
    flagsDisabled: boolean;
}

@observer
export default class TxpEventsPanel extends React.Component<TxpEventsPanelProps, {}> {
    render() {
        let { formFlags, mailboxCalendarConfiguration, flagsDisabled } = this.props;

        return (
            <div className={styles.txpEventsPanel}>
                <Label>{strings.options_txp_addEventsTitle}</Label>
                {EventsInOptionsPageInOrder.map(eventType => {
                    if (!isEventTypeEnabled(eventType as TxpEventFlags)) {
                        return null;
                    }

                    let checked = getFallbackValueIfNull(
                        formFlags[eventType],
                        mailboxCalendarConfiguration[eventType]
                    );
                    return (
                        <OptionsCheckbox
                            checked={checked}
                            disabled={flagsDisabled}
                            onChange={this.updateFlagFromCheckbox(eventType)}
                            label={getLabelForTxpFlag(eventType as TxpEventFlags)}
                        />
                    );
                })}
            </div>
        );
    }

    /**
     * On change handler for the OptionsCheckbox
     */
    private updateFlagFromCheckbox = (flag: string) => (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        updateTxpFlag(flag as TxpEventFlags, checked);
    };
}
